import { BrowserRouter as Router, Routes, Route } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import { Suspense, lazy } from "react";
import "./ticker.css";

// Lazy load pages for code-splitting
const HomePage = lazy(() => import("./pages/Home"));
const Article = lazy(() => import("./pages/Article"));
const Author = lazy(() => import("./pages/Author"));
const Articles = lazy(() => import("./pages/Articles"));
const Topics = lazy(() => import("./pages/Topics"));
const TopicHub = lazy(() => import("./pages/TopicHub"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Loading fallback - minimal to avoid CLS
function PageLoader() {
  return (
    <div className="min-h-screen bg-[#FEFAF8]" />
  );
}

// Shared routes component for both SSR and client
export function AppRoutes() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/artikel/:slug" element={<Article />} />
        <Route path="/artikelen" element={<Articles />} />
        <Route path="/auteur/marcel-van-der-torre" element={<Author />} />
        <Route path="/onderwerpen" element={<Topics />} />
        <Route path="/onderwerpen/:slug" element={<TopicHub />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

// Client-side app wrapper
export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppRoutes />
      </Router>
    </HelmetProvider>
  );
}
